export default __webpack_public_path__ + "static/media/CNo.86-1.b99a7083.jpg";